import { createRouter } from '@tanstack/react-router'

import { getQueryClient } from './Common/base/queryClient'
import RouteErrorPage from './Common/components/error/RouteErrorPage'
import RouteNotFoundPage from './Common/components/error/RouteNotFoundPage'
import { routeTree } from './routeTree.gen'

export const router = createRouter({
    routeTree,
    context: { queryClient: getQueryClient() },
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    defaultPendingMs: 150,
    defaultPendingMinMs: 400,
    defaultErrorComponent: RouteErrorPage,
    defaultNotFoundComponent: RouteNotFoundPage,
})

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router
    }
}
